import { Link } from "react-router-dom";
import { Facebook, Mail, ArrowUpRight } from "lucide-react";
import { Magnetic } from "./Magnetic";
import { FadeUp } from "./Reveal";
import { CONTACT_EMAIL, FACEBOOK_URL } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="dark-section bg-[#0A0A0A] text-white">
      <div className="container-x pt-24 pb-10">
        <FadeUp>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">Ready when you are</p>
          <h2 className="font-display mt-6 text-[13vw] font-bold uppercase leading-[0.9] tracking-tighter lg:text-[10vw]">
            Let's<br />Talk.
          </h2>
        </FadeUp>

        <div className="mt-12 flex flex-col gap-8 border-t border-white/10 pt-12 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <p className="font-display text-lg font-bold uppercase">Mahseri<sup>®</sup> Web</p>
            <p className="mt-4 text-sm font-light leading-relaxed text-white/60">
              We build high-converting websites that turn your online presence into a customer-generating asset.
            </p>
            <Magnetic strength={0.2}>
              <Link
                to="/contact"
                data-testid="footer-build-my-website-btn"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-black transition-transform duration-300 hover:scale-105"
              >
                Build My Website <ArrowUpRight size={16} />
              </Link>
            </Magnetic>
          </div>

          <div className="footer-links grid min-w-0 grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-3 lg:gap-12">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">Navigate</p>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link data-testid="footer-link-home" className="hover:text-white" to="/">Home</Link></li>
                <li><Link data-testid="footer-link-why" className="hover:text-white" to="/why">Why A Website</Link></li>
                <li><Link data-testid="footer-link-work" className="hover:text-white" to="/work">Examples</Link></li>
                <li><Link data-testid="footer-link-about" className="hover:text-white" to="/about">About</Link></li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">Services</p>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link data-testid="footer-service-web-design" className="hover:text-white" to="/services">Web Design</Link></li>
                <li><Link data-testid="footer-service-local-seo" className="hover:text-white" to="/services">Local SEO</Link></li>
                <li><Link data-testid="footer-service-leads" className="hover:text-white" to="/services">Lead Systems</Link></li>
                <li><Link data-testid="footer-service-maintenance" className="hover:text-white" to="/services">Maintenance</Link></li>
              </ul>
            </div>
            <div className="col-span-2 min-w-0 sm:col-span-1">
              <p className="text-xs uppercase tracking-[0.2em] text-white/40">Contact</p>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li>
                  <a data-testid="footer-email-link" href={`mailto:${CONTACT_EMAIL}`} className="inline-flex max-w-full items-center gap-2 break-all hover:text-white">
                    <Mail size={14} className="shrink-0" /> {CONTACT_EMAIL}
                  </a>
                </li>
                <li>
                  <a data-testid="footer-facebook-link" href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-white">
                    <Facebook size={14} /> Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row">
          <p>© {new Date().getFullYear()} Mahseri Web. All rights reserved.</p>
          <p>Your website should work when you don't.</p>
        </div>
      </div>
    </footer>
  );
}
